<template>
  <div class="w-full">
    <h1 class="font-bold text-gray-800 text-2xl">Latest Emails</h1>
    <div class="flex flex-col mt-4">
      <div class="bg-white rounded-lg shadow-md mb-8" v-for="email in emails">
        <div
          class="p-4 bg-gray-600 shadow-md rounded-lg w-full cursor-pointer select-none"
          v-on:click="$router.push('/admin/tools/mail/' + email.id)"
        >
          <div class="flex flex-row items-center">
            <div class="flex-1 overflow-none">
              <h2 class="text-lg font-semibold text-white whitespace-no-wrap">
                {{ email.title }}
              </h2>
            </div>
            <div
              class="bg-gray-300 px-2 py-1 rounded"
              :title="localTime(email.created_at)"
              v-tippy
            >
              {{ email.created_at | timeAgo }}
            </div>
          </div>
        </div>
        <div class="py-4">
          <div class="w-full flex flex-row justify-between px-4 my-4">
            <div class="flex flex-col items-center content-center">
              <h3 class="font-bold text-xl">
                {{ email.analytics.sentEmails }}
              </h3>
              <span class="text-uppercase text-gray-500 font-bold"
                >Emails Sent</span
              >
            </div>
            <div class="flex flex-col items-center content-center">
              <h3 class="font-bold text-xl">
                {{ email.analytics.openedEmails }}
              </h3>
              <span class="text-uppercase text-gray-500 font-bold"
                >Email Views</span
              >
            </div>
            <div class="flex flex-col items-center content-center">
              <h3 class="font-bold text-xl">
                {{ email.analytics.linksFollowed }}
              </h3>
              <span class="text-uppercase text-gray-500 font-bold"
                >Video Views</span
              >
            </div>
            <div class="flex flex-col items-center content-center">
              <h3 class="font-bold text-xl">{{ email.analytics.purchases }}</h3>
              <span class="text-uppercase text-gray-500 font-bold"
                >Purchases</span
              >
            </div>
          </div>
          <div class="mt-4 px-4">
            <span class="font-bold text-uppercase text-gray-800"
              >Most Viewed Video</span
            >
            <span class="ml-2" v-if="email.analytics.mostViewedVideo == null"
              >N/A</span
            >
            <div class="" v-if="email.analytics.mostViewedVideo !== null">
              <div class="flex mt-1">
                <img
                  class="h-24 w-auto rounded-lg"
                  :src="email.analytics.mostViewedVideo.video.thumbnailUrl"
                />
                <div class="px-4">
                  <p class="text-lg font-semibold">
                    {{ email.analytics.mostViewedVideo.video.title }}
                  </p>
                  <p>{{ email.analytics.mostViewedVideo.video.user.name }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 px-4">
            <span class="font-bold text-uppercase text-gray-800"
              >Videos Included</span
            >
            <div class="" v-if="email.analytics.mostViewedVideo !== null">
              <div class="flex flex-wrap">
                <div
                  class="w-full md:w-1/2 flex flex-row items-center mb-4"
                  v-for="video in email.rawVideos"
                >
                  <img
                    class="h-24 w-auto rounded-lg"
                    :src="video.thumbnailUrl"
                  />
                  <div class="px-4">
                    <p class="text-lg font-semibold">{{ video.title }}</p>
                    <p>{{ video.user.name }}</p>
                    <p>ID: {{ video.id }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="mt-4 px-4">
                        <span class="font-bold text-uppercase text-gray-800">Custom Pricing Information</span>
                        <div class="" v-if="email.analytics.mostViewedVideo !== null">
                            <div class="flex flex-wrap mt-1">
                                <div class="w-full flex justify-between mb-4">
                                    <span>Video ID</span>
                                    <span>Default Price</span>
                                    <span v-for="val in Object.keys(email.pricing)[0]">
                                        {{ val }}
                                    </span>
                                </div>
                                <div class="w-full flex justify-between mb-4" v-for="video in email.rawVideos">
                                    <span>{{ video.id }}</span>
                                    <span>{{ video.price }}</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/events";
import * as Config from "@/config";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

import Card from "@/components/partials/Card";

export default {
  name: "MailList",
  data() {
    return {
      emails: [],
      checkAll: true,
      networks: {},
      title: null,
      hoursAgo: 24,
      loading: false,

      polling: false
    };
  },
  components: {
    Card
  },
  mounted() {
    this.getNationalNetworks();
    this.loadLatestEmails();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    loadLatestEmails() {
      this.loading = true;

      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/mail/latest",
          this.getAuthorizationHeader()
        )
        .then(response => {
          this.$set(this, "emails", response.data.data);
          this.$set(this, "loading", false);
          console.log(response.data.data[0].pricing);
          console.log(Object.keys(response.data.data[0].pricing)[0]);
        });
    },
    localTime(dt) {
      return moment
        .utc(dt)
        .local()
        .format("MMMM Do YYYY, h:mm a");
    },
    getNationalNetworks() {
      var _this = this;
      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/networks?type=national",
          this.getAuthorizationHeader()
        )
        .then(response => {
          _this.networks = response.data;
        });
    },
    getNetworkName(key) {
      console.log(key);
      return this.networks.filter(data => data.id == key);
    }
  },
  filters: {
    timecode: function(value) {
      if (value !== null) {
        var seconds = Math.floor(value % 60).toString();
        var minutes = Math.floor(value / 60).toString();
        if (seconds.length === 1) {
          seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
      }
    },
    timeAgo: function(date) {
      return moment.utc(date).fromNow();
    },
    displayLocalDateTime: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do YYYY, h:mm a");
    }
  }
};
</script>
